import { render } from "./QA.html?vue&type=template&id=18dc5acc&scoped=true&external"
import script from "./QA.js?vue&type=script&lang=javascript&external"
export * from "./QA.js?vue&type=script&lang=javascript&external"

import "./QA.scss?vue&type=style&index=0&id=18dc5acc&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18dc5acc"]])

export default __exports__